export default "__VITE_ASSET__8a02f051__"